//Auto generated
import {Documents} from '../Documents';
import {SofDisagreeReasons} from '../Line';
import {Document} from './Document';
import {EaCase} from './EstateAdmin';
import {Case as ICaseCase} from '../Case';
import {CaseAddresses} from "../caseAddresses";

export class CaseAddress {
    addressDbSourced: boolean;
    buildingName: string;
    buildingNumber: string;
    buildingname?: string;
    buildingnumber?: string;
    caseAddressId: number;
    caseFileId: number;
    coordsSource: number;
    country: string;
    county: string;
    dateCreated: Date;
    dateEnd: Date;
    dateReplaced: Date;
    dateStart: Date;
    dependantThoroughfareDescriptor: string;
    dependantThoroughfareName: string;
    doubleDependantLocality: string;
    easting: number;
    guid: string;
    locality: string;
    northing: number;
    organisation: string;
    paon: string;
    postcode: string;
    postcodeString: string;
    propertyType: string;
    saon: string;
    street: string;
    subBuildingName: string;
    subbuildingname?: string;
    thoroughfareDescriptor: string;
    thoroughfare?: string;
    thoroughfareName: string;
    toid: string;
    townCity: string;
    towncity?: string;
    uprn: string;
    versionId: number;

    constructor(_buildingname: string, _buildingnumber: string,
                _country: string, _county: string
        , _caseaddressid: number, _casefileid: number, _locality: string,
                _organisation: string, _postcode: string, _dependantThoroughfareName: string, _thoroughfare: string, _street: string, _subbuildingname: string,
                _towncity: string, _uprn: string, _northing: number, _easting: number
    ) {
        this.buildingName = _buildingname;
        this.buildingNumber = _buildingnumber;
        this.country = _country;
        this.county = _county;
        this.caseAddressId = _caseaddressid;
        this.caseFileId = _casefileid;
        this.locality = _locality;
        this.organisation = _organisation;
        this.postcode = _postcode;
        this.dependantThoroughfareName = _dependantThoroughfareName;
        this.thoroughfareName = _thoroughfare;
        this.street = _street;
        this.subBuildingName = _subbuildingname;
        this.townCity = _towncity;
        this.uprn = _uprn;
        this.northing = _northing;
        this.easting = _easting;
    }

}

export interface CaseDictionary {
    attributeId: number;
    attributeValueId: number;
    caseDictionaryId: number;
    caseFileId: number;
    index: number;
    key: string;
    value: string;
}


export interface CaseDocument {
    caseDocumentId?: number | null;
    caseFileId?: number;
    document?: Document;
    documentId?: number;
    description?: string;
}

export interface CaseType {
    description: string;
    id: number;
}

export interface XmlDocument {
    id: number;
    workflowDocumentTypeId: number;
    xmlCategoryId: number;
    xmlContent: string;
}

export interface CaseXml {
    caseId: number;
    id: number;
    xmlDocument: XmlDocument;
    xmlId: number;
}

export interface CaseAddress2 {
    addressDbSourced: boolean;
    buildingName: string;
    buildingNumber: string;
    buildingIdentifier: string;
    caseAddressId: number;
    caseFileId: number;
    coordsSource: number;
    country: string;
    county: string;
    dateCreated: Date;
    dateEnd: Date;
    dateReplaced: Date;
    dateStart: Date;
    dependantThoroughfareDescriptor: string;
    dependantThoroughfareName: string;
    doubleDependantLocality: string;
    easting: number;
    guid: string;
    locality: string;
    northing: number;
    organisation: string;
    paon: string;
    postcode: string;
    postcodeString: string;
    propertyType: string;
    saon: string;
    street: string;
    subBuildingName: string;
    thoroughfareDescriptor: string;
    thoroughfareName: string;
    toid: string;
    townCity: string;
    uprn: string;
    versionId: number;
}

export interface CaseDictionary2 {
    attributeId: number;
    attributeValueId: number;
    caseDictionaryId: number;
    caseFileId: number;
    index: number;
    key: string;
    value: string;
}

export interface Document2 {
    archivedFilePath: string;
    contentType: string;
    createdBy: number;
    createdDate: Date;
    description: string;
    detailId: number;
    documentBytes: string;
    documentFormat: string;
    documentId: number;
    documentPath: string;
    documentSourceId: number;
    documentTypeId: number;
    fileLength: number;
    fileName: string;
    isArchived: boolean;
    modifiedBy: number;
    modifiedDate: Date;
    orderId: number;
    replaced: boolean;
    replacementDocumentId: number;
    userVisible: boolean;
    visible: boolean;
    wfDocumentType: number;
}

export interface CaseDocument2 {
    caseDocumentId: number;
    caseFileId: number;
    document: Document2;
    documentId: number;
}

export interface CaseType2 {
    description: string;
    id: number;
}

export interface XmlDocument2 {
    id: number;
    workflowDocumentTypeId: number;
    xmlCategoryId: number;
    xmlContent: string;
}

export interface CaseXml2 {
    caseId: number;
    id: number;
    xmlDocument: XmlDocument2;
    xmlId: number;
}

export interface MatterType {
    description: string;
    id: number;
}

export interface Point {
    pointId: number;
    polygonId: number;
    x: number;
    y: number;
}

export interface Polygon {
    description: string;
    points: Point[];
    polygonId: number;
    polygonSetId: number;
    toid: string;
}

export interface PolygonSet {
    caseFileId: number;
    dateCreated: Date;
    isActive: boolean;
    lineDetailId: number;
    orderDetailId: number;
    polygonSetId: number;
    polygons: Polygon[];
}

export interface Voucher {
    caseAddressId: number;
    caseFileId: number;
    dateUsed: Date;
    promotionId: number;
    tenant: number;
    voucherCode: string;
    voucherDate: Date;
    voucherId: number;
}

export interface WorkflowTitle {
    buildingName: string;
    buildingNumber: string;
    county: string;
    description: string;
    postCode: string;
    street: string;
    subBuildingName: string;
    tenure: string;
    titleNumber: string;
    town: string;
}

export interface CaseAddress3 {
    addressDbSourced: boolean;
    buildingName: string;
    buildingNumber: string;
    caseAddressId: number;
    caseFileId: number;
    coordsSource: number;
    country: string;
    county: string;
    dateCreated: Date;
    dateEnd: Date;
    dateReplaced: Date;
    dateStart: Date;
    dependantThoroughfareDescriptor: string;
    dependantThoroughfareName: string;
    doubleDependantLocality: string;
    easting: number;
    guid: string;
    locality: string;
    northing: number;
    organisation: string;
    paon: string;
    postcode: string;
    postcodeString: string;
    propertyType: string;
    saon: string;
    street: string;
    subBuildingName: string;
    thoroughfareDescriptor: string;
    toid: string;
    townCity: string;
    uprn: string;
    versionId: number;
}

export interface AttributeValue {
    description: string;
    id: number;
    isBespokePrice: boolean;
    isDefaultValue: boolean;
    amountProposed: string;
    sortOrder: number;
    value: string;
}

export interface LineDetailAttribute {
    attributeType: number;
    attributeValues: AttributeValue[];
    description: string;
    id: number;
    isExcluded: boolean;
    isHidden: boolean;
    isMutable: boolean;
    isRequired: boolean;
    isSensitive: boolean;
    isSplittable: boolean;
    maximum: number;
    minimum: number;
    name: string;
    sortOrder: number;
    validationExpression: string;
    validationMessage: string;
    attributeId: number;
    attributeName: string;
    attributeNameDescription: string;
    attributeValue: string;
    attributeValueDescription: string;
    attributeValueId: number;
    id1: number;
    lineDetailId: number;
}

export interface Point2 {
    pointId: number;
    polygonId: number;
    x: number;
    y: number;
}

export interface Polygon2 {
    description: string;
    points: Point2[];
    polygonId: number;
    polygonSetId: number;
    toid: string;
}

export interface PolygonSet2 {
    caseFileId: number;
    dateCreated: Date;
    isActive: boolean;
    lineDetailId: number;
    orderDetailId: number;
    polygonSetId: number;
    polygons: Polygon2[];
}

export interface LineDetail {
    accountId: number;
    adminPrice: number;
    adminVat: number;
    baseNetPrice: number;
    baseNetTax: number;
    baseSearchPrice: number;
    baseSearchVat: number;
    baseTotalGrossPrice: number;
    caseFileId: number;
    companyName: number;
    confirmed: boolean;
    costPrice: number;
    failureMessage: string;
    id: number;
    instanceId: number;
    insuranceOrderType: number;
    isQuote: boolean;
    isReseller: boolean;
    ismanualtitle: boolean;
    line: string;
    lineDetailDocuments: Documents[];
    lineDetailAttributes: LineDetailAttribute[];
    lineIdGuid: string;
    lmReferredStatus: string;
    netPrice: number;
    netTax: number;
    orderDateTime: Date;
    pdfFileName: string;
    packId: number;
    pafAddress: boolean;
    policyNumber: string;
    polygonId: number;
    polygonSet: PolygonSet2;
    priceMatrixId: number;
    processed: boolean;
    productId: number;
    productName: string;
    productSentDateTime: Date;
    providerId: number;
    referredDetailId: number;
    referredPdfFileName: string;
    referrerId: number;
    refresheroriginalorderid: number;
    resellername: string;
    searchPrice: number;
    searchVat: number;
    sessionGuid: string;
    sofDisagreeReasons: SofDisagreeReasons[];
    status: number;
    statusString: string;
    totalGrossPrice: number;
    userPrice: number;
    workflowInstanceId: string;
}

export interface LineHazard {
    covered: boolean;
    hazard: string;
    id: number;
    lineIdGuid: string;
}

export interface Line {
    accountId: number;
    accountUserId: number;
    case: Case;
    caseAddressId: number;
    caseFileId: number;
    clientRef: string;
    isTest: boolean;
    orderSource: number;
    poNumber: string;
    caseAddress: CaseAddress3;
    deliverToEmail: string;
    lineDateTime: Date;
    lineDetails: LineDetail[];
    lineHazards: LineHazard[];
    lineIdGuid: string;
    lineTypeId: number;
    pafAddressFormat: boolean;
}

export interface MatterType2 {
    description: string;
    id: number;
}

export interface CaseAddress4 {
    addressDbSourced: boolean;
    buildingName: string;
    buildingNumber: string;
    caseAddressId: number;
    caseFileId: number;
    coordsSource: number;
    country: string;
    county: string;
    dateCreated: Date;
    dateEnd: Date;
    dateReplaced: Date;
    dateStart: Date;
    dependantThoroughfareDescriptor: string;
    dependantThoroughfareName: string;
    doubleDependantLocality: string;
    easting: number;
    guid: string;
    locality: string;
    northing: number;
    organisation: string;
    paon: string;
    postcode: string;
    postcodeString: string;
    propertyType: string;
    saon: string;
    street: string;
    subBuildingName: string;
    thoroughfareDescriptor: string;
    toid: string;
    townCity: string;
    uprn: string;
    versionId: number;
}

export interface CaseDictionary3 {
    attributeId: number;
    attributeValueId: number;
    caseDictionaryId: number;
    caseFileId: number;
    index: number;
    key: string;
    value: string;
}

export interface Document3 {
    archivedFilePath: string;
    contentType: string;
    createdBy: number;
    createdDate: Date;
    description: string;
    detailId: number;
    documentBytes: string;
    documentFormat: string;
    documentId: number;
    documentPath: string;
    documentSourceId: number;
    documentTypeId: number;
    fileLength: number;
    fileName: string;
    isArchived: boolean;
    modifiedBy: number;
    modifiedDate: Date;
    orderId: number;
    replaced: boolean;
    replacementDocumentId: number;
    userVisible: boolean;
    visible: boolean;
    wfDocumentType: number;
}

export interface CaseDocument3 {
    caseDocumentId: number;
    caseFileId: number;
    document: Document3;
    documentId: number;
}

export interface CaseType3 {
    description: string;
    id: number;
}

export interface XmlDocument3 {
    id: number;
    workflowDocumentTypeId: number;
    xmlCategoryId: number;
    xmlContent: string;
}

export interface CaseXml3 {
    caseId: number;
    id: number;
    xmlDocument: XmlDocument3;
    xmlId: number;
}

export interface MatterType3 {
    description: string;
    id: number;
}

export interface Point3 {
    pointId: number;
    polygonId: number;
    x: number;
    y: number;
}

export interface Polygon3 {
    description: string;
    points: Point3[];
    polygonId: number;
    polygonSetId: number;
    toid: string;
}

export interface PolygonSet3 {
    caseFileId: number;
    dateCreated: Date;
    isActive: boolean;
    lineDetailId: number;
    orderDetailId: number;
    polygonSetId: number;
    polygons: Polygon3[];
}

export interface Voucher2 {
    caseAddressId: number;
    caseFileId: number;
    dateUsed: Date;
    promotionId: number;
    tenant: number;
    voucherCode: string;
    voucherDate: Date;
    voucherId: number;
}

export interface WorkflowTitle2 {
    buildingName: string;
    buildingNumber: string;
    county: string;
    description: string;
    postCode: string;
    street: string;
    subBuildingName: string;
    tenure: string;
    titleNumber: string;
    town: string;
}

export interface Case2 {
    accountId: number;
    accountUserId: number;
    caseAddress: CaseAddress4[];
    caseDictionary: CaseDictionary3[];
    caseDocuments: CaseDocument3[];
    caseFileId: number;
    caseFileStatusId: number;
    caseReference: string;
    caseType: CaseType3;
    caseTypeId: number;
    caseXmls: CaseXml3[];
    createdBy: number;
    createdOn: Date;
    defaultLimitOfIndemnity: number;
    deleted: boolean;
    lender: number;
    lines: string[];
    matterType: MatterType3;
    matterTypeId: number;
    modifiedBy: number;
    modifiedOn: Date;
    orders: string[];
    ownerId: number;
    polygonSets: PolygonSet3[];
    propertyValue: number;
    residential: boolean;
    titleNumber: string;
    voucher: Voucher2[];
    workflowTitle: WorkflowTitle2[];
}

export interface CaseAddress5 {
    addressDbSourced: boolean;
    buildingName: string;
    buildingNumber: string;
    caseAddressId: number;
    caseFileId: number;
    coordsSource: number;
    country: string;
    county: string;
    dateCreated: Date;
    dateEnd: Date;
    dateReplaced: Date;
    dateStart: Date;
    dependantThoroughfareDescriptor: string;
    dependantThoroughfareName: string;
    doubleDependantLocality: string;
    easting: number;
    guid: string;
    locality: string;
    northing: number;
    organisation: string;
    paon: string;
    postcode: string;
    postcodeString: string;
    propertyType: string;
    saon: string;
    street: string;
    subBuildingName: string;
    thoroughfareDescriptor: string;
    toid: string;
    townCity: string;
    uprn: string;
    versionId: number;
}

export interface CaseAddress6 {
    addressDbSourced: boolean;
    buildingName: string;
    buildingNumber: string;
    caseAddressId: number;
    caseFileId: number;
    coordsSource: number;
    country: string;
    county: string;
    dateCreated: Date;
    dateEnd: Date;
    dateReplaced: Date;
    dateStart: Date;
    dependantThoroughfareDescriptor: string;
    dependantThoroughfareName: string;
    doubleDependantLocality: string;
    easting: number;
    guid: string;
    locality: string;
    northing: number;
    organisation: string;
    paon: string;
    postcode: string;
    postcodeString: string;
    propertyType: string;
    saon: string;
    street: string;
    subBuildingName: string;
    thoroughfareDescriptor: string;
    toid: string;
    townCity: string;
    uprn: string;
    versionId: number;
}

export interface CaseDictionary4 {
    attributeId: number;
    attributeValueId: number;
    caseDictionaryId: number;
    caseFileId: number;
    index: number;
    key: string;
    value: string;
}

export interface Document4 {
    archivedFilePath: string;
    contentType: string;
    createdBy: number;
    createdDate: Date;
    description: string;
    detailId: number;
    documentBytes: string;
    documentFormat: string;
    documentId: number;
    documentPath: string;
    documentSourceId: number;
    documentTypeId: number;
    fileLength: number;
    fileName: string;
    isArchived: boolean;
    modifiedBy: number;
    modifiedDate: Date;
    orderId: number;
    replaced: boolean;
    replacementDocumentId: number;
    userVisible: boolean;
    visible: boolean;
    wfDocumentType: number;
}

export interface CaseDocument4 {
    caseDocumentId: number;
    caseFileId: number;
    document: Document4;
    documentId: number;
}

export interface CaseType4 {
    description: string;
    id: number;
}

export interface XmlDocument4 {
    id: number;
    workflowDocumentTypeId: number;
    xmlCategoryId: number;
    xmlContent: string;
}

export interface CaseXml4 {
    caseId: number;
    id: number;
    xmlDocument: XmlDocument4;
    xmlId: number;
}

export interface MatterType4 {
    description: string;
    id: number;
}

export interface Point4 {
    pointId: number;
    polygonId: number;
    x: number;
    y: number;
}

export interface Polygon4 {
    description: string;
    points: Point4[];
    polygonId: number;
    polygonSetId: number;
    toid: string;
}

export interface PolygonSet4 {
    caseFileId: number;
    dateCreated: Date;
    isActive: boolean;
    lineDetailId: number;
    orderDetailId: number;
    polygonSetId: number;
    polygons: Polygon4[];
}

export interface Voucher3 {
    caseAddressId: number;
    caseFileId: number;
    dateUsed: Date;
    promotionId: number;
    tenant: number;
    voucherCode: string;
    voucherDate: Date;
    voucherId: number;
}

export interface WorkflowTitle3 {
    buildingName: string;
    buildingNumber: string;
    county: string;
    description: string;
    postCode: string;
    street: string;
    subBuildingName: string;
    tenure: string;
    titleNumber: string;
    town: string;
}

export interface Case3 {
    accountId: number;
    accountUserId: number;
    caseAddress: CaseAddress6[];
    caseDictionary: CaseDictionary4[];
    caseDocuments: CaseDocument4[];
    caseFileId: number;
    caseFileStatusId: number;
    caseReference: string;
    caseType: CaseType4;
    caseTypeId: number;
    caseXmls: CaseXml4[];
    createdBy: number;
    createdOn: Date;
    defaultLimitOfIndemnity: number;
    deleted: boolean;
    lender: number;
    lines: string[];
    matterType: MatterType4;
    matterTypeId: number;
    modifiedBy: number;
    modifiedOn: Date;
    orders: string[];
    ownerId: number;
    polygonSets: PolygonSet4[];
    propertyValue: number;
    residential: boolean;
    titleNumber: string;
    voucher: Voucher3[];
    workflowTitle: WorkflowTitle3[];
}

export interface CaseAddress7 {
    addressDbSourced: boolean;
    buildingName: string;
    buildingNumber: string;
    caseAddressId: number;
    caseFileId: number;
    coordsSource: number;
    country: string;
    county: string;
    dateCreated: Date;
    dateEnd: Date;
    dateReplaced: Date;
    dateStart: Date;
    dependantThoroughfareDescriptor: string;
    dependantThoroughfareName: string;
    doubleDependantLocality: string;
    easting: number;
    guid: string;
    locality: string;
    northing: number;
    organisation: string;
    paon: string;
    postcode: string;
    postcodeString: string;
    propertyType: string;
    saon: string;
    street: string;
    subBuildingName: string;
    thoroughfareDescriptor: string;
    toid: string;
    townCity: string;
    uprn: string;
    versionId: number;
}

export interface AttributeValue2 {
    description: string;
    id: number;
    isBespokePrice: boolean;
    isDefaultValue: boolean;
    amountProposed: string;
    sortOrder: number;
    value: string;
}

export interface LineDetailAttribute2 {
    attributeType: number;
    attributeValues: AttributeValue2[];
    description: string;
    id: number;
    isExcluded: boolean;
    isHidden: boolean;
    isMutable: boolean;
    isRequired: boolean;
    isSensitive: boolean;
    isSplittable: boolean;
    maximum: number;
    minimum: number;
    name: string;
    sortOrder: number;
    validationExpression: string;
    validationMessage: string;
    attributeId: number;
    attributeName: string;
    attributeNameDescription: string;
    attributeValue: string;
    attributeValueDescription: string;
    attributeValueId: number;
    id1: number;
    lineDetailId: number;
}

export interface Point5 {
    pointId: number;
    polygonId: number;
    x: number;
    y: number;
}

export interface Polygon5 {
    description: string;
    points: Point5[];
    polygonId: number;
    polygonSetId: number;
    toid: string;
}

export interface PolygonSet5 {
    caseFileId: number;
    dateCreated: Date;
    isActive: boolean;
    lineDetailId: number;
    orderDetailId: number;
    polygonSetId: number;
    polygons: Polygon5[];
}

export interface LineDetail2 {
    accountId: number;
    adminPrice: number;
    adminVat: number;
    baseNetPrice: number;
    baseNetTax: number;
    baseSearchPrice: number;
    baseSearchVat: number;
    baseTotalGrossPrice: number;
    caseFileId: number;
    companyName: number;
    confirmed: boolean;
    costPrice: number;
    failureMessage: string;
    id: number;
    instanceId: number;
    insuranceOrderType: number;
    isQuote: boolean;
    isReseller: boolean;
    ismanualtitle: boolean;
    line: string;
    lineDetailAttributes: LineDetailAttribute2[];
    lineIdGuid: string;
    lmReferredStatus: string;
    netPrice: number;
    netTax: number;
    orderDateTime: Date;
    pdfFileName: string;
    packId: number;
    pafAddress: boolean;
    policyNumber: string;
    polygonId: number;
    polygonSet: PolygonSet5;
    priceMatrixId: number;
    processed: boolean;
    productId: number;
    productName: string;
    productSentDateTime: Date;
    providerId: number;
    referredDetailId: number;
    referredPdfFileName: string;
    referrerId: number;
    refresheroriginalorderid: number;
    resellername: string;
    searchPrice: number;
    searchVat: number;
    sessionGuid: string;
    status: number;
    statusString: string;
    totalGrossPrice: number;
    userPrice: number;
    workflowInstanceId: string;
}

export interface LineHazard2 {
    covered: boolean;
    hazard: string;
    id: number;
    lineIdGuid: string;
}

export interface Line2 {
    accountId: number;
    accountUserId: number;
    case: Case3;
    caseAddressId: number;
    caseFileId: number;
    clientRef: string;
    isTest: boolean;
    orderSource: number;
    poNumber: string;
    caseAddress: CaseAddress7;
    deliverToEmail: string;
    lineDateTime: Date;
    lineDetails: LineDetail2[];
    lineHazards: LineHazard2[];
    lineIdGuid: string;
    lineTypeId: number;
    pafAddressFormat: boolean;
}

export interface AttributeValue3 {
    description: string;
    id: number;
    isBespokePrice: boolean;
    isDefaultValue: boolean;
    amountProposed: string;
    sortOrder: number;
    value: string;
}

export interface LineDetailAttribute3 {
    attributeType: number;
    attributeValues: AttributeValue3[];
    description: string;
    id: number;
    isExcluded: boolean;
    isHidden: boolean;
    isMutable: boolean;
    isRequired: boolean;
    isSensitive: boolean;
    isSplittable: boolean;
    maximum: number;
    minimum: number;
    name: string;
    sortOrder: number;
    validationExpression: string;
    validationMessage: string;
    attributeId: number;
    attributeName: string;
    attributeNameDescription: string;
    attributeValue: string;
    attributeValueDescription: string;
    attributeValueId: number;
    id1: number;
    lineDetailId: number;
}

export interface Point6 {
    pointId: number;
    polygonId: number;
    x: number;
    y: number;
}

export interface Polygon6 {
    description: string;
    points: Point6[];
    polygonId: number;
    polygonSetId: number;
    toid: string;
}

export interface PolygonSet6 {
    caseFileId: number;
    dateCreated: Date;
    isActive: boolean;
    lineDetailId: number;
    orderDetailId: number;
    polygonSetId: number;
    polygons: Polygon6[];
}

export interface AttributeValue4 {
    description: string;
    id: number;
    isBespokePrice: boolean;
    isDefaultValue: boolean;
    amountProposed: string;
    sortOrder: number;
    value: string;
}

export interface OrderDetailAttribute {
    attributeType: number;
    attributeValues: AttributeValue4[];
    description: string;
    id: number;
    isExcluded: boolean;
    isHidden: boolean;
    isMutable: boolean;
    isRequired: boolean;
    isSensitive: boolean;
    isSplittable: boolean;
    maximum: number;
    minimum: number;
    name: string;
    sortOrder: number;
    validationExpression: string;
    validationMessage: string;
    attributeId: number;
    attributeName: string;
    attributeNameDescription: string;
    attributeValue: string;
    attributeValueDescription: string;
    attributeValueId: number;
    id1: number;
    orderDetailId: number;
}

export interface Document5 {
    archivedFilePath: string;
    contentType: string;
    createdBy: number;
    createdDate: Date;
    description: string;
    detailId: number;
    documentBytes: string;
    documentFormat: string;
    documentId: number;
    documentPath: string;
    documentSourceId: number;
    documentTypeId: number;
    fileLength: number;
    fileName: string;
    isArchived: boolean;
    modifiedBy: number;
    modifiedDate: Date;
    orderId: number;
    replaced: boolean;
    replacementDocumentId: number;
    userVisible: boolean;
    visible: boolean;
    wfDocumentType: number;
}

export interface OrderDetailDocument {
    document: Document5;
    documentId: number;
    orderDetailDocumentId: number;
    orderDetailId: number;
}

export interface OrderDetailParish {
    certificateReport: string;
    county: string;
    id: number;
    orderDetailId: number;
    parishId: number;
    parishName: string;
    placeName: string;
    risk: number;
    searchResult: number;
    searchResultString: string;
}

export interface OrderDetail {
    accountId: number;
    adminPrice: number;
    adminVat: number;
    baseNetPrice: number;
    baseNetTax: number;
    baseSearchPrice: number;
    baseSearchVat: number;
    baseTotalGrossPrice: number;
    caseFileId: number;
    companyName: number;
    confirmed: boolean;
    costPrice: number;
    failureMessage: string;
    id: number;
    instanceId: number;
    insuranceOrderType: number;
    isQuote: boolean;
    isReseller: boolean;
    ismanualtitle: boolean;
    line: Line2;
    lineDetailAttributes: LineDetailAttribute3[];
    lineIdGuid: string;
    lmReferredStatus: string;
    netPrice: number;
    netTax: number;
    orderDateTime: Date;
    pdfFileName: string;
    packId: number;
    pafAddress: boolean;
    policyNumber: string;
    polygonId: number;
    polygonSet: PolygonSet6;
    priceMatrixId: number;
    processed: boolean;
    productId: number;
    productName: string;
    productSentDateTime: Date;
    providerId: number;
    referredDetailId: number;
    referredPdfFileName: string;
    referrerId: number;
    refresheroriginalorderid: number;
    resellername: string;
    searchPrice: number;
    searchVat: number;
    sessionGuid: string;
    status: number;
    statusString: string;
    totalGrossPrice: number;
    userPrice: number;
    workflowInstanceId: string;
    cancellationReason: number;
    cancellationState: number;
    dueDate: Date;
    estimatedDate: Date;
    inceptionDateTime: Date;
    interventionDateTime: Date;
    interventionDescription: string;
    interventionResubmitDateTime: Date;
    interventionStatus: number;
    isInsurance: boolean;
    lineDetailId: number;
    orderDetailAttributes: OrderDetailAttribute[];
    orderDetailBeingReplaced: number;
    orderDetailDocument: OrderDetailDocument[];
    orderDetailParishes: OrderDetailParish[];
    orderId: number;
    replacementOrderDetailId: number;
    sendCancellationTo: string;
    thirdPartyReference: string;
}

export interface OrderHazard {
    covered: boolean;
    hazard: string;
    id: number;
    orderId: number;
}

export interface Voucher4 {
    caseAddressId: number;
    caseFileId: number;
    dateUsed: Date;
    promotionId: number;
    tenant: number;
    voucherCode: string;
    voucherDate: Date;
    voucherId: number;
}

export interface OrderVoucher {
    id: number;
    orderId: number;
    voucher: Voucher4;
    voucherId: number;
    voucherUsageType: number;
}

export interface PostalAddress {
    addressLine1: string;
    addressLine2: string;
    county: string;
    id: number;
    postcode: string;
    town: string;
}

export interface Order {
    accountId: number;
    accountUserId: number;
    case: Case2;
    caseAddressId: number;
    caseFileId: number;
    clientRef: string;
    isTest: boolean;
    orderSource: number;
    poNumber: string;
    caseAddress: CaseAddress5;
    deliverToEmail: string;
    dimensionInsuranceOrderId: number;
    dimensionSearchOrderId: number;
    id: number;
    invoiceCreated: boolean;
    invoiceRecipientParty: string;
    invoiceSent: boolean;
    lineDetailGuid: string;
    orderDateTime: Date;
    orderDetails: OrderDetail[];
    orderHazards: OrderHazard[];
    orderSentToVisma: boolean;
    orderStatus: number;
    orderStatusString: string;
    orderVouchers: OrderVoucher[];
    pafAddressFormat: boolean;
    postOrder: boolean;
    postalAddress: PostalAddress;
    replaceDraft: boolean;
    thirdPartyReference: string;
}

export interface Point7 {
    pointId: number;
    polygonId: number;
    x: number;
    y: number;
}

export interface Polygon7 {
    description: string;
    points: Point7[];
    polygonId: number;
    polygonSetId: number;
    toid: string;
}

export interface PolygonSet7 {
    caseFileId: number;
    dateCreated: Date;
    isActive: boolean;
    lineDetailId: number;
    orderDetailId: number;
    polygonSetId: number;
    polygons: Polygon7[];
}

export interface Voucher5 {
    caseAddressId: number;
    caseFileId: number;
    dateUsed: Date;
    promotionId: number;
    tenant: number;
    voucherCode: string;
    voucherDate: Date;
    voucherId: number;
}

export interface WorkflowTitle4 {
    buildingName: string;
    buildingNumber: string;
    county: string;
    description: string;
    postCode: string;
    street: string;
    subBuildingName: string;
    tenure: string;
    titleNumber: string;
    town: string;
}

export interface AccountType {
    description: string;
    fcaCheckType: number;
    id: number;
}

export interface FinanceAddress {
    addressLine1: string;
    addressLine2: string;
    county: string;
    id: number;
    postcode: string;
    town: string;
}

export interface FinanceContact {
    department: string;
    email: string;
    id: number;
    name: string;
    position: string;
    telephone: string;
    title: string;
}

export interface MainContact {
    department: string;
    email: string;
    id: number;
    name: string;
    position: string;
    telephone: string;
    title: string;
}

export interface RegisteredCompanyAddress {
    addressLine1: string;
    addressLine2: string;
    county: string;
    id: number;
    postcode: string;
    town: string;
}

export interface Registration {
    accountType: number;
    clcNumber: string;
    companyName: string;
    companyNumber: string;
    epfNumber: string;
    fsaRegNumber: string;
    sanctionRef: string;
    sraNumber: string;
    vatNumber: string;
}

export interface TradingAddress {
    addressLine1: string;
    addressLine2: string;
    county: string;
    id: number;
    postcode: string;
    town: string;
}

export interface Account {
    acceptedTerms: boolean;
    acceptedTermsOn: Date;
    accountStartDate: Date;
    accountType: AccountType;
    allowSearchWithoutGridRef: boolean;
    approved: Date;
    bulkDelivery: boolean;
    canHoldClientMoney: boolean;
    canOrderInsurance: boolean;
    changedDate: Date;
    clspiToba: boolean;
    clsrsToba: boolean;
    companyLinkedIn: string;
    companyName: string;
    companyReg: string;
    companyStatus: number;
    companyTwitter: string;
    companyType: number;
    creditLimit: number;
    encryptXml: boolean;
    fax: string;
    fcaCheckDate: Date;
    fcaOutcomeOptionsId: number;
    fcaUrl: string;
    financeAddress: FinanceAddress;
    financeContact: FinanceContact;
    howHear: string;
    howHearDetail: string;
    icoNumber: string;
    id: number;
    inceptionDaysBackdatable: number;
    invoiceFinanceContact: boolean;
    invoiceFrequency: number;
    isReferrer: boolean;
    isTestAccount: boolean;
    lastAccountOrderDate: Date;
    lastAccountXmlOrderDate: Date;
    mainContact: MainContact;
    masterAccount: string;
    masterAccountId: number;
    numberOfFeeEarners: number;
    optOutOfRecommended: boolean;
    pricing: number;
    referrer: string;
    registeredCompanyAddress: RegisteredCompanyAddress;
    registeredCompanyName: string;
    registeredCompanyNumber: string;
    registration: Registration;
    registrationDate: Date;
    sicId: number;
    salesPerson: string;
    seenTerms: boolean;
    statements: boolean;
    status: number;
    suppressAllCoverSheets: boolean;
    suppressInvoices: boolean;
    telephone: string;
    tenant: number;
    tradingAddress: TradingAddress;
    vatNumber: string;
    vatReg: string;
    websiteAddress: string;
    xmL_VSOF_Enabled: boolean;
}

export interface AccountType2 {
    description: string;
    fcaCheckType: number;
    id: number;
}

export interface FinanceAddress2 {
    addressLine1: string;
    addressLine2: string;
    county: string;
    id: number;
    postcode: string;
    town: string;
}

export interface FinanceContact2 {
    department: string;
    email: string;
    id: number;
    name: string;
    position: string;
    telephone: string;
    title: string;
}

export interface MainContact2 {
    department: string;
    email: string;
    id: number;
    name: string;
    position: string;
    telephone: string;
    title: string;
}

export interface RegisteredCompanyAddress2 {
    addressLine1: string;
    addressLine2: string;
    county: string;
    id: number;
    postcode: string;
    town: string;
}

export interface Registration2 {
    accountType: number;
    clcNumber: string;
    companyName: string;
    companyNumber: string;
    epfNumber: string;
    fsaRegNumber: string;
    sanctionRef: string;
    sraNumber: string;
    vatNumber: string;
}

export interface TradingAddress2 {
    addressLine1: string;
    addressLine2: string;
    county: string;
    id: number;
    postcode: string;
    town: string;
}

export interface Account2 {
    acceptedTerms: boolean;
    acceptedTermsOn: Date;
    accountStartDate: Date;
    accountType: AccountType2;
    allowSearchWithoutGridRef: boolean;
    approved: Date;
    bulkDelivery: boolean;
    canHoldClientMoney: boolean;
    canOrderInsurance: boolean;
    changedDate: Date;
    clspiToba: boolean;
    clsrsToba: boolean;
    companyLinkedIn: string;
    companyName: string;
    companyReg: string;
    companyStatus: number;
    companyTwitter: string;
    companyType: number;
    creditLimit: number;
    encryptXml: boolean;
    fax: string;
    fcaCheckDate: Date;
    fcaOutcomeOptionsId: number;
    fcaUrl: string;
    financeAddress: FinanceAddress2;
    financeContact: FinanceContact2;
    howHear: string;
    howHearDetail: string;
    icoNumber: string;
    id: number;
    inceptionDaysBackdatable: number;
    invoiceFinanceContact: boolean;
    invoiceFrequency: number;
    isReferrer: boolean;
    isTestAccount: boolean;
    lastAccountOrderDate: Date;
    lastAccountXmlOrderDate: Date;
    mainContact: MainContact2;
    masterAccount: string;
    masterAccountId: number;
    numberOfFeeEarners: number;
    optOutOfRecommended: boolean;
    pricing: number;
    referrer: string;
    registeredCompanyAddress: RegisteredCompanyAddress2;
    registeredCompanyName: string;
    registeredCompanyNumber: string;
    registration: Registration2;
    registrationDate: Date;
    sicId: number;
    salesPerson: string;
    seenTerms: boolean;
    statements: boolean;
    status: number;
    suppressAllCoverSheets: boolean;
    suppressInvoices: boolean;
    telephone: string;
    tenant: number;
    tradingAddress: TradingAddress2;
    vatNumber: string;
    vatReg: string;
    websiteAddress: string;
    xmL_VSOF_Enabled: boolean;
}

export interface AccountUser {
    account: Account2;
    accreditationCheckStatus: number;
    contactPreferences: number;
    email: string;
    firstName: string;
    id: number;
    isDisabled: boolean;
    lastLoggedIn: Date;
    lastLoggedInXml: Date;
    lastName: string;
    marketingPreference: number;
    newUser: boolean;
    onlySeeOwnCaseFiles: boolean;
    personalLinkedIn: string;
    position: string;
    resetKey: string;
    suppressCmsChaseEmails: boolean;
    suppressCmsNewCaseEmail: boolean;
    telephone: string;
    testUser: boolean;
    title: string;
    userName: string;
    userRole: number;
    waitForAllProducts: boolean;
}

export interface AccountComposite {
    account: Account;
    accountUser: AccountUser;
}

export interface CurrentCaseAddress {
    addressDbSourced: boolean;
    buildingName: string;
    buildingNumber: string;
    caseAddressId: number;
    caseFileId: number;
    coordsSource: number;
    country: string;
    county: string;
    dateCreated: Date;
    dateEnd: Date;
    dateReplaced: Date;
    dateStart: Date;
    dependantThoroughfareDescriptor: string;
    dependantThoroughfareName: string;
    doubleDependantLocality: string;
    easting: number;
    guid: string;
    locality: string;
    northing: number;
    organisation: string;
    paon: string;
    postcode: string;
    postcodeString: string;
    propertyType: string;
    saon: string;
    street: string;
    subBuildingName: string;
    thoroughfareDescriptor: string;
    toid: string;
    townCity: string;
    uprn: string;
    versionId: number;
}

export interface Voucher6 {
    caseAddressId: number;
    caseFileId: number;
    dateUsed: Date;
    promotionId: number;
    tenant: number;
    voucherCode: string;
    voucherDate: Date;
    voucherId: number;
}

export class CreateCaseRequest {
    caseReference: string;
    caseTypeId: number;
    matterTypeId: number;
    titleNumber: string;
    defaultItems: CaseDictionary[];
    currentCaseAddress: CurrentCaseAddress;
    eaCase: EaCase;

    static fromCase(caseObj: Case): CreateCaseRequest {
        const request = new CreateCaseRequest();
        request.caseReference = caseObj.caseReference;
        request.caseTypeId = caseObj.caseTypeId;
        request.matterTypeId = caseObj.matterTypeId;
        request.titleNumber = caseObj.titleNumber;
        request.currentCaseAddress = caseObj.currentCaseAddress;
        request.eaCase = caseObj.eaCase;
        return request;
    }

    static fromICaseCase(caseObj: ICaseCase): CreateCaseRequest {
        const request = new CreateCaseRequest();
        request.caseReference = caseObj.caseReference;
        request.caseTypeId = caseObj.CaseTypeId;
        request.matterTypeId = caseObj.matterTypeId ?? caseObj.mattertypeid;
        request.titleNumber = undefined;
        request.defaultItems = [];
        request.currentCaseAddress = this.mapToCurrentCaseAddress(caseObj.address);
        request.eaCase = undefined;
        return request;
    }

    private static mapToCurrentCaseAddress(source: CaseAddresses): CurrentCaseAddress {
        return {
            addressDbSourced: source.AddressDbSourced,
            buildingName: source.buildingname,
            buildingNumber: source.buildingnumber,
            caseAddressId: source.caseaddressid,
            caseFileId: source.casefileid,
            coordsSource: typeof source.coordssource === 'number' ? source.coordssource : Number(source.coordssource || 0),
            country: source.country,
            county: source.county,
            dependantThoroughfareName: source.dependantthoroughfarename || source.dependentthoroughfarename,
            dependantThoroughfareDescriptor: null,
            doubleDependantLocality: null,
            easting: source.easting,
            locality: source.locality,
            northing: source.northing,
            organisation: source.organisation,
            paon: source.paon,
            postcode: source.postcode,
            postcodeString: source.postcode,
            propertyType: source.propertytype,
            saon: source.saon,
            street: source.street,
            subBuildingName: source.subbuildingname,
            thoroughfareDescriptor: source.thoroughfaredescriptor,
            toid: null,
            townCity: source.towncity || source.town,
            uprn: source.uprn,

            dateCreated: null,
            dateEnd: null,
            dateReplaced: null,
            dateStart: null,
            guid: null,
            versionId: null
        } as CurrentCaseAddress;
    }


}

export class Case {
    accountId: number;
    accountUserId: number;
    caseAddress: CaseAddress[];
    caseDictionary: CaseDictionary[];
    caseDocuments: CaseDocument[];
    caseFileId: number;
    caseFileStatusId: number;
    caseReference: string;
    caseType: CaseType;
    caseTypeId: number;
    caseXmls: CaseXml[];
    createdBy: number;
    createdOn: Date;
    defaultLimitOfIndemnity: number;
    deleted: boolean;
    lender: number;
    lines: Line[];
    matterType: MatterType2;
    matterTypeId: number;
    modifiedBy: number;
    modifiedOn: Date;
    orders: Order[];
    ownerId: number;
    polygonSets: PolygonSet[];
    propertyValue: number;
    residential: boolean;
    titleNumber: string;
    voucher: Voucher5[];
    workflowTitle: WorkflowTitle4[];
    accountComposite: AccountComposite;
    currentCaseAddress: CurrentCaseAddress;
    isSampleGeneration: boolean;
    noteCount: number;
    notificationCount: number;
    tenant: number;
    vouchers: Voucher6[];
    eaCase: EaCase

    constructor(_casereference: string, _date: Date, _lines: Line[],
                _orders: Order[], _status: number, _caseaddresses: CaseAddress[]) {
        this.caseReference = _casereference;
        this.createdOn = _date;
        this.orders = _orders;
        this.caseFileStatusId = _status;
        this.caseAddress = _caseaddresses;
        this.lines = _lines;
    }
}

export class ExistingCasePopup {
    accountComposite: AccountComposite;
    accountId: number;
    accountUserId: number;
    buildingName: string;
    buildingNumber: string;
    caseAddress: CaseAddress[];
    caseDictionary: CaseDictionary[];
    caseDocuments: CaseDocument[];
    caseFileId: number;
    caseFileStatusId: number;
    caseReference: string;
    caseType: CaseType;
    caseTypeId: number;
    caseXmls: CaseXml[];
    createdBy: number;
    createdOn: Date;
    defaultLimitOfIndemnity: number;
    deleted: boolean;
    eaCase: EaCase;
    isSampleGeneration: boolean;
    lender: number;
    lines: Line[];
    locality: string;
    matterType: MatterType2;
    matterTypeId: number;
    modifiedBy: number;
    modifiedOn: Date;
    noteCount: number;
    notificationCount: number;
    orders: Order[];
    organisation: string;
    ownerId: number;
    polygonSets: PolygonSet[];
    postCode: string;
    propertyValue: number;
    residential: boolean;
    street: string;
    subBuildingName: string;
    tenant: number;
    titleNumber: string;
    townCity: string;
    vouchers: Voucher6[];
    voucher: Voucher5[];
    workflowTitle: WorkflowTitle4[];

    constructor(_casereference: string, _date: Date, _lines: Line[],
                _orders: Order[], _status: number, _caseaddresses: CaseAddress[]) {
        this.caseReference = _casereference;
        this.createdOn = _date;
        this.orders = _orders;
        this.caseFileStatusId = _status;
        this.caseAddress = _caseaddresses;
        this.lines = _lines;
    }
}

